jQuery(document).ready(function ($) {
	$('.tab-button').click(function () {
		var tab = $(this).data('tab');
		$('.tab-active').removeClass('tab-active');
		$(this).addClass('tab-active');
		$('#' + tab).addClass('tab-active');
	});
});
